import Login from './standard-login/login';
import ReactDOM from 'react-dom';
import React from 'react';
import { detectWavesApp } from './waves-app-login/waves-apps-provider';
import WavesAppsLogin from './waves-app-login/login';
import { initFacebookForLogin } from '../../../domain/facebook/facebook-login-provider';
import { initGoogleForLogin } from '../../../domain/google/google-login-provider';

/**
 * entry point
 */
const init = () => {
    const $root = document.getElementById('membership-login-app');
    if (!$root) return;

    const wavesApp = detectWavesApp();
    const isWavesApp = !!wavesApp && wavesApp.isWavesApp;

    initFacebookForLogin();
    initGoogleForLogin(isWavesApp, wavesApp);

    ReactDOM.render(
        <React.StrictMode>
            { !isWavesApp && <Login /> }
            { isWavesApp && <WavesAppsLogin wavesAppDetectionData={ wavesApp } /> }
        </React.StrictMode>,
        $root
    );
};

document.addEventListener('DOMContentLoaded', () => {
    init();
});

export {};